export default "__VITE_ASSET__CBLJkcIz__"